import { createDatasetSlice } from 'src/redux/helpers';
import { RequestMethod, pepApiRequest } from 'src/services';
import { generateApiPath } from 'src/utils';
import {
  API_SOLUTION_RULES_MANAGEMENT_GET,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_RULES_MANAGEMENT,
} from '../constants';
import { mapSolutionRulesManagementData } from './utils';

const api = (solutionId: string) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generateApiPath(API_SOLUTION_RULES_MANAGEMENT_GET, {
      solutionId,
    }),
  }).then((items) => mapSolutionRulesManagementData(items));

const solutionsRulesManagmentSlice = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_RULES_MANAGEMENT,
});

export default solutionsRulesManagmentSlice;
